<template>
    <div>
      <div class="gobuy-head-custom" v-if="!$IFR.is_iframe">
        <div class="logo">
          <img src="../../../assets/image/logo1.png" alt="" />
        </div>
        <div class="head-nav">
          <mt-button icon="back" @click="$router.go(-1)" class="back-btn"></mt-button>
          <div class="nav-center">
            <span class="nav-title active">{{ $t('MenuGiftCard') }}</span>
            <router-link :to="{ name: 'HomeGoBuy' }" class="nav-title">{{ $t('BlindBox') }}</router-link>
            <router-link :to="{ name: 'Hunt' }" class="nav-title">{{ $t('hunt70') }}</router-link>
          </div>
          <router-link :to="{ name: 'MyCardList' }" class="my-card-link">{{ $t("My Card") }} >></router-link>
        </div>
      </div>
      <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>
        <div class="box">
          <!-- 卡片类型切换 -->
          <div class="card-switch">
            <span
              :class="['switch-item', cardType === 'gold' ? 'active' : '']"
              @click="switchCard('gold')"
            >
              Gold Card
            </span>
            <span class="divider">|</span>
            <span
              :class="['switch-item', cardType === 'gift' ? 'active' : '']"
              @click="switchCard('gift')"
            >
              Gift Card
            </span>
          </div>
          <div class="box_list"  v-for="(item,index) in giftCardList" :key="index">
            <img :src="item.image" :class="item.is_buy==1 ? '' : 'filter'">
            <div class="box_list_rt">
              <div class="list_rt_txt1">{{item.name}}</div>
              <div class="list_rt_txt2"></div>
              <div class="list_rt_btn" @click="goDetail(item)">{{$t('Buy now')}}</div>
              <!-- <div class="list_rt_btn" v-if="cardType == 'gift'" @click="goDetail(item)">{{$t('Buy now')}}</div>
              <div class="list_rt_btn" v-else style="background-color: #ccc;">Coming soon</div> -->
            </div>
          </div>
        </div>
        <empty-record  v-if="giftCardList && !giftCardList.length"></empty-record>
    </div>
</template>

<script>
import { Toast,Indicator } from 'mint-ui'
import { getGiftCardList,getGoldCardList } from '../../../api/giftcard'
export default {
  name: 'GiftCardList',
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      pageTotal: 1, // 总页数
      giftCardList: false, // 商品列表
      isLoad: false,
      cardType: 'gold'
    }
  },
  components: {},
  mounted(){
    this.getDataList()
  },
  methods: {
    switchCard(type) {
      if (this.cardType === type) return
      this.cardType = type
      this.giftCardList = false

      Indicator.open()
      const api = type === 'gold' ? getGoldCardList : getGiftCardList

      api().then(res => {
        Indicator.close()
        this.giftCardList = res.result.list || res.result
      })
    },
    getDataList(){
      Indicator.open()
      getGoldCardList().then(res => {
        Indicator.close()
        this.giftCardList = res.result.list || res.result
      })
    },
    goDetail (item) {
      if(item.is_buy == 2){
        this.timer = setTimeout(() => {
          this.$router.push({ 'name': 'Shares'})
        }, 1500);
        return Toast(this.$t("is not share"));//您还未完成分享任务
      }

      if(item.is_buy == 3){
        return Toast(this.$t("is buied"));//您今天已经购买过了
      }
      this.$router.push({ 'name': 'GiftCardDetails', 'query': { 'data': JSON.stringify(item) } })
    },
    getPointVoucherList (ispush) {
      Indicator.open()
      let params = this.params
      getGiftCardList(params).then(res => {
        Indicator.close()
        const list = res.result.list || res.result
        if (ispush) {
          this.giftCardList = this.giftCardList.concat(list)
        } else {
          this.giftCardList = list
        }
        this.pageTotal = res.result.page_total
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore && this.params.page <= this.pageTotal) {
        this.loading = false
        this.getPointVoucherList(true)
      }
    },
  }
}
</script>

<style scoped lang="scss">
.filter{filter: grayscale(100%);}
.gobuy-head-custom {
  width: 100%;
  height: 4.2rem;
  position: fixed;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-image: url("../../../assets/image/homeHbgc.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .logo {
    top: 25px;
    left: 12px;
    z-index: 99;
    margin: .5rem 0;
    img {
      width: 3.5rem;
    }
  }

  .head-nav {
    position: relative;
    display: flex;
    align-items: center;
    background-color: #F15E60;
    height: 1.8rem;
    padding: 0 .4rem;

    .back-btn {
      color: #fff;
      background: transparent;
      border: none;
      font-size: .8rem;
      padding: 0;
      margin-right: .2rem;
    }

    .nav-center {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
    }

    .nav-title {
      font-size: .7rem;
      color: rgba(255, 255, 255, 0.7);
      margin: 0 .4rem;
      white-space: nowrap;
      text-decoration: none;

      &.active {
        color: #fff;
        font-weight: bold;
      }
    }

    .my-card-link {
      margin-left: auto;
      font-size: .6rem;
      color: #ffffff;
      text-decoration: underline;
      white-space: nowrap;
    }
  }
}
.box{
  width: 100%;
  overflow: hidden;
  padding-bottom: 100px;
  .box_list{
    width: 100%;
    height: 6rem;
    background: #FFD7C5;
    border-radius: .12rem .12rem .12rem .12rem;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    padding: 0 2%;
    margin-bottom: 10px;
    img{
      max-width: 40%;
      height: 5rem;
      object-fit: contain;
    }
    .box_list_rt{
      width: 50%;
      .list_rt_txt1{
        font-size: $subFontSize;

      }
      .list_rt_txt2{
        font-size: $subFontSize;
        margin: 0.6rem 0;
      }
      .list_rt_btn{
        width: 70%;
        margin-left: 10%;
        height:1.5rem;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: $subFontSize;
        color: #FFFFFF;
        line-height: 1.5rem;
        text-align: center;
        background: #EF4618;
        border-radius: .4rem;
      }
      .list_rt_btn2{
        width: 70%;
        margin-left: 10%;
        height:1.5rem;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: $subFontSize;
        color: #FFFFFF;
        line-height: 1.5rem;
        text-align: center;
        background: #989898;
        border-radius: .4rem;
      }
    }
  }
}
.list-wrap {padding:0 15px}
.list-wrap .list-wrap-item {display: inline-block;margin-top: 10px;width:50%;}
.list-wrap .list-wrap-item:nth-child(2n+2) {text-align: right}
.card-switch {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0 15px;
  font-size: 14px;
  color: #999;

  .switch-item {
    cursor: pointer;
    padding: 0 8px;
  }

  .active {
    color: #EF4618;
    font-weight: bold;
    text-decoration: underline;
  }

  .divider {
    margin: 0 5px;
  }
}

</style>
